<template>
  <div class="contact-details-section">
    <div class="contact-details-section-left">
      <h3 class="heading">Contact Details</h3>
      <div>
        <div class="mt-4"></div>
        <div class="contact-details">
          <font-awesome-icon icon="phone-square-alt"></font-awesome-icon>
          <p>
            <a href="tel:999999000">
              999 999 000
            </a>
          </p>
        </div>
        <div class="contact-details">
          <font-awesome-icon icon="envelope-open"></font-awesome-icon>
          <p>
            <a href="mailto:someone@example.com?Subject=Hello%20again"
              >info@edfore.com</a
            >
          </p>
        </div>
        <div class="contact-details">
          <font-awesome-icon icon="map-marker-alt"></font-awesome-icon>
          <p>
            950 Grand Ave. <br />
            Algonquin, IL 60102 <br />
            Pin : 454543
          </p>
        </div>
        <div class="social-widgets">
          <div class="circle fb">
            <font-awesome-icon :icon="['fab', 'facebook-f']" />
          </div>
          <div class="circle twitter">
            <font-awesome-icon :icon="['fab', 'twitter']" />
          </div>
        </div>
      </div>
    </div>
    <div class="contact-details-section-right">
      <h3 class="heading mt-3 mb-3">Message Us</h3>
      <b-form v-if="show" data-vv-scope="contact">
        <b-form-group id="input-group-2" label-for="contact-us-input-1">
          <b-form-input
            id="contact-us-input-1"
            v-model.trim="name"
            placeholder="Name*"
            v-validate="'required|alpha_spaces|min:3|max:20'"
            :class="{ 'is-invalid': errors.has('contact.Name') }"
            name="Name"
          ></b-form-input>
          <b-form-invalid-feedback id="contact-name-live-feedback">
            <small>{{ errors.first("contact.Name") }}</small>
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group id="input-group-1" label-for="contact-us-input-2">
          <b-form-input
            id="contact-us-input-2"
            v-model="email"
            type="email"
            placeholder="Email*"
            v-validate="'required|email'"
            name="Email"
            :class="{ 'is-invalid': errors.has('contact.Email') }"
          ></b-form-input>
          <b-form-invalid-feedback id="contact-email-live-feedback">
            <small>{{ errors.first("contact.Email") }}</small>
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group id="input-group-3" label-for="contact-us-input-3">
          <b-form-input
            id="contact-us-input-3"
            placeholder="Phone*"
            v-model="phone"
            v-validate="'required||min:10|max:10|numeric'"
            name="Phone Number"
            :class="{ 'is-invalid': errors.has('contact.Phone Number') }"
          ></b-form-input>
          <b-form-invalid-feedback id="contact-Mobile-Number-live-feedback">
            <small>{{ errors.first("contact.Phone Number") }}</small>
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group id="input-group-4" label-for="contact-us-input-4">
          <b-form-textarea
            id="contact-us-input-4"
            v-model="message"
            placeholder="Message*"
            rows="3"
            max-rows="6"
            :class="{ 'is-invalid': errors.has('contact.Message') }"
            name="Message"
            v-validate="'required|min:5'"
          ></b-form-textarea>
          <b-form-invalid-feedback id="contact-1-live-feedback">
            <small>{{ errors.first("contact.Message") }}</small>
          </b-form-invalid-feedback>
        </b-form-group>

        <b-button
          size="lg"
          pill
          variant="primary"
          type="submit"
          @click.prevent="action('contact')"
        >
          <span>Send your message</span>
          <font-awesome-icon icon="arrow-right" size="xs" />
        </b-button>
      </b-form>
    </div>
  </div>
</template>

<script>
import { customerApi } from "../services/customerApi";

export default {
  name: "contact-us",
  data() {
    return {
      email: "",
      name: "",
      phone: "",
      message: "",
      show: true,
      showContactError: true
    };
  },
  methods: {
    action(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.showContactError = false;
          this.contactUs();
        } else {
          this.showContactError = true;
        }
      });
    },
    contactUs() {
      const contactDetails = {
        name: this.name,
        email: this.email,
        phone: this.phone,
        message: this.message
      };
      customerApi
        .contactUs(contactDetails)
        .then(res => {
          this.$bvToast.toast(
            "We Will Contact you soon. Thank You for choosing us",
            {
              title: "Contact Us",
              autoHideDelay: 1000,
              appendToast: true
            }
          );
        })
        .catch(e => {
          this.$bvToast.toast("Error Occurred. Please try again ", {
            title: "Contact Us",
            autoHideDelay: 1000,
            appendToast: true
          });
        });
      this.resetForm();
    },
    resetForm() {
      this.name = "";
      this.email = "";
      this.phone = "";
      this.message = "";
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    }
  }
};
</script>

<style scoped></style>
